import React from 'react';
import { Row, Col } from 'reactstrap';
import { FormGroup, Label, Input } from 'reactstrap';

//Components
import TextField from '../../../../components/TextField/TextField';

//Helpers
import { validarCampos } from '../../../../helpers/ValidadorDeCampos';

export default function IdentificacaoPrefeitura({ errors, setErrors, prefeitura, setPrefeitura, campos }) {
    //Opções de status da prefeitura
    const optionsStatus = [
        { value: "Ativo", text: "Ativo" },
        { value: "Bloqueado", text: "Bloqueado" },
        { value: "Cancelado", text: "Cancelado" },
        { value: "Inativo", text: "Inativo" },
    ]

    //Opções de cadastro gerador
    const optionsCadastroGerador = [
        { value: "Secretaria/Transportador/Gerador", text: "Secretaria/Transportador/Gerador" },
        { value: "Secretaria/Transportador", text: "Secretaria/Transportador" },
        { value: "Secretaria/Gerador", text: "Secretaria/Gerador" },
        { value: "Secretaria", text: "Secretaria" },
        { value: "Transportador", text: "Transportador" },
        { value: "Gerador", text: "Gerador" },
    ];

    //Opções de cadastro gerador
    const optionsCadastroContratos = [
        { value: "Transportador", text: "Transportador" },
        { value: "Gerador", text: "Gerador (PGRS)" },
        { value: "Transportador/Gerador", text: "Transportador/Gerador (PGRS)" },
    ];

    //Change dos campos da prefeitura
    const onChangePrefeitura = (e) => {
        const { name, value } = e.target;
        const _prefeitura = {
            ...prefeitura,
            [name]: value
        }
        const campo = campos.filter(c => c.name == name);
        const erros = validarCampos(_prefeitura, campo);
        if (erros[1].length == 0) {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors(_errors);
        } else {
            setErrors({ ...errors, ...erros[0] });
        }
        setPrefeitura(_prefeitura);
    }
    //Change do imagens da prefeitura
    const onChangeImagens = (e) => {
        const { name, files } = e.target;

        if (!files || !files[0]) {
            setPrefeitura({
                ...prefeitura,
                [name]: null
            });
            return;
        }

        const FR = new FileReader();

        FR.addEventListener("load", function (evt) {
            let base64 = evt.target.result;
            setPrefeitura({
                ...prefeitura,
                [name]: base64.replace("data:image/png;base64,", "").replace("data:image/jpeg;base64,", "")
            })
        });

        FR.readAsDataURL(e.target.files[0]);
    }

    return (
        <div>
            <Row className='mb-4'>
                <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
            </Row>
            <Row>
                <Col md={"12"} lg="3">
                    <TextField
                        maxLength={"100"}
                        label={"* Fantasia"}
                        invalid={errors.fantasia ? true : false}
                        value={prefeitura.fantasia}
                        onChange={onChangePrefeitura}
                        name="fantasia"
                    />
                    {errors.fantasia && <span className={"form-control-label text-danger"}>{errors.fantasia.message}</span>}
                </Col>
                <Col md="12" lg="3">
                    <TextField
                        type={"text"}
                        maxLength={"7"}
                        label={"* Sigla do documento de coleta"}
                        name={"identificacaoDocumentoColeta"}
                        onChange={onChangePrefeitura}
                        value={prefeitura.identificacaoDocumentoColeta}
                        invalid={errors.identificacaoDocumentoColeta}
                    />
                    {errors.totalVistoriasEnquadramento && <span className={"form-control-label text-danger"}>{errors.totalVistoriasEnquadramento.message}</span>}
                </Col>
                <Col md={"12"} lg="2">
                    <TextField
                        label={"Status"}
                        type={"select"}
                        options={optionsStatus}
                        invalid={errors.status ? true : false}
                        value={prefeitura.status}
                        onChange={onChangePrefeitura}
                        name="status"
                    />
                    {errors.status && <span className={"form-control-label text-danger"}>{errors.status.message}</span>}
                </Col>
                <Col md={"12"} lg="4">
                    <TextField
                        label={"E-mail em Cópia"} 
                        options={optionsStatus} 
                        value={prefeitura.emailCC}
                        onChange={onChangePrefeitura}
                        name="emailCC"
                    /> 
                </Col> 
                <Col md={"12"} lg="4">
                    <TextField
                        maxLength={"100"}
                        label={"* Município"}
                        invalid={errors.cidade ? true : false}
                        value={prefeitura.cidade}
                        onChange={onChangePrefeitura}
                        name="cidade"
                    />
                    {errors.cidade && <span className={"form-control-label text-danger"}>{errors.cidade.message}</span>}
                </Col>

                <Col md={"12"} lg="4">
                    <TextField
                        name="descricaoDocumentoColeta"
                        label={"Descrição do Documento de Coleta"}
                        type={"text"}
                        value={prefeitura.descricaoDocumentoColeta}
                        onChange={onChangePrefeitura}
                    />
                    {errors.status && <span className={"form-control-label text-danger"}>{errors.status.message}</span>}
                </Col>

                <Col md={"12"} lg="4">
                    <TextField
                        label={"Responsável pelo cadastro dos geradores"}
                        type={"select"}
                        options={optionsCadastroGerador}
                        invalid={errors.quemCadastraGeradores ? true : false}
                        value={prefeitura.quemCadastraGeradores}
                        onChange={onChangePrefeitura}
                        name="quemCadastraGeradores"
                    />
                    {errors.quemCadastraGeradores && <span className={"form-control-label text-danger"}>{errors.quemCadastraGeradores.message}</span>}
                </Col>

                <Col md={"12"} lg="4">
                    <TextField
                        label={"Responsável pelo cadastro de contratos"}
                        type={"select"}
                        options={optionsCadastroContratos}
                        value={prefeitura.quemCadastraContrato}
                        onChange={onChangePrefeitura}
                        name="quemCadastraContrato"
                    />
                </Col>

            </Row>
            <Row>
                <Col md={"12"} lg={"4"}>
                    <FormGroup tag="fieldset">
                        <legend className='label'>Imprimir 2ª Via do Ticket na coleta do gerador?</legend>
                        <div className='d-flex align-items-center justify-content-start'>
                            <FormGroup check className='me-3'>
                                <Label check>
                                    <Input type="radio" name="imprimi2ViaTicketColeta" onChange={onChangePrefeitura} value={false} checked={prefeitura.imprimi2ViaTicketColeta == "false" || prefeitura.imprimi2ViaTicketColeta == false} />{' '}
                                    Não
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check>
                                    <Input type="radio" name="imprimi2ViaTicketColeta" onChange={onChangePrefeitura} value={true} checked={prefeitura.imprimi2ViaTicketColeta == "true" || prefeitura.imprimi2ViaTicketColeta == true} />{' '}
                                    Sim
                                </Label>
                            </FormGroup>

                        </div>
                        {errors.imprimi2ViaTicketColeta && <span className={"form-control-label text-danger"}>{errors.imprimi2ViaTicketColeta.message}</span>}
                    </FormGroup>
                </Col>
                <Col md={"12"} lg={"4"}>
                    <FormGroup tag="fieldset">
                        <legend className='label'>Obrigatório capturar foto na "Não Coleta"?</legend>
                        <div className='d-flex align-items-center justify-content-start'>
                            <FormGroup check className='me-3'>
                                <Label check>
                                    <Input type="radio" name="obrigatorioFotoNaoColeta" onChange={onChangePrefeitura} value={false} checked={prefeitura.obrigatorioFotoNaoColeta == "false" || prefeitura.obrigatorioFotoNaoColeta == false} />{' '}
                                    Não
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check>
                                    <Input type="radio" name="obrigatorioFotoNaoColeta" onChange={onChangePrefeitura} value={true} checked={prefeitura.obrigatorioFotoNaoColeta == "true" || prefeitura.obrigatorioFotoNaoColeta == true} />{' '}
                                    Sim
                                </Label>
                            </FormGroup>

                        </div>
                        {errors.obrigatorioFotoNaoColeta && <span className={"form-control-label text-danger"}>{errors.obrigatorioFotoNaoColeta.message}</span>}
                    </FormGroup>
                </Col>

                <Col md={"12"} lg={"4"}>
                    <FormGroup tag="fieldset">
                        <legend className='label'>Requer Análise de PGRS?</legend>
                        <div className='d-flex align-items-center justify-content-start'>
                            <FormGroup check className='me-3'>
                                <Label check>
                                    <Input type="radio" name="analisePGRS" onChange={onChangePrefeitura} value={false} checked={prefeitura.analisePGRS == "false" || prefeitura.analisePGRS == false} />{' '}
                                    Não
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check>
                                    <Input type="radio" name="analisePGRS" onChange={onChangePrefeitura} value={true} checked={prefeitura.analisePGRS == "true" || prefeitura.analisePGRS == true} />{' '}
                                    Sim
                                </Label>
                            </FormGroup>

                        </div>
                        {errors.analisePGRS && <span className={"form-control-label text-danger"}>{errors.analisePGRS.message}</span>}
                    </FormGroup>
                </Col>

                <Col md={"12"} lg={"4"}>
                    <FormGroup tag="fieldset">
                        <legend className='label'>Notificar Coleta Sem PGRS?</legend>
                        <div className='d-flex align-items-center justify-content-start'>
                            <FormGroup check className='me-3'>
                                <Label check>
                                    <Input type="radio" name="notificarColetaSemPGRS" onChange={onChangePrefeitura} value={false} checked={prefeitura.notificarColetaSemPGRS == "false" || prefeitura.notificarColetaSemPGRS == false} />{' '}
                                    Não
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check>
                                    <Input type="radio" name="notificarColetaSemPGRS" onChange={onChangePrefeitura} value={true} checked={prefeitura.notificarColetaSemPGRS == "true" || prefeitura.notificarColetaSemPGRS == true} />{' '}
                                    Sim
                                </Label>
                            </FormGroup>

                        </div>
                        {errors.notificarColetaSemPGRS && <span className={"form-control-label text-danger"}>{errors.notificarColetaSemPGRS.message}</span>}
                    </FormGroup>
                </Col>

                <Col md={"12"} lg="12">
                    <TextField
                        label={"Logotipo"}
                        type={"file"}
                        invalid={errors.logotipo ? true : false}
                        onChange={onChangeImagens}
                        name="logotipo"
                        accept="image/png,image/jpeg" />
                    {errors.logotipo && <span className={"form-control-label text-danger"}>{errors.logotipo.message}</span>}
                </Col>
                {prefeitura.logotipo &&
                    <Col md={"12"} lg={"12"} className="text-center">
                        <img
                            width={"300px"}
                            id="img_logotipo"
                            src={"data:image/png;base64," + prefeitura.logotipo}
                        />
                    </Col>
                }

                <Col md={"12"} lg="12">
                    <TextField
                        label={"Logotipo Secretaria"}
                        type={"file"}
                        onChange={onChangeImagens}
                        name="logotipoSecretaria"
                        accept="image/png,image/jpeg" />
                </Col>
                {prefeitura.logotipoSecretaria &&
                    <Col md={"12"} lg={"12"} className="text-center">
                        <img
                            width={"300px"}
                            id="img_logotipoSecretaria"
                            src={"data:image/png;base64," + prefeitura.logotipoSecretaria}
                        />
                    </Col>
                }

                <Col md={"12"} lg="12">
                    <TextField
                        label={"Logotipo Branco"}
                        type={"file"}
                        onChange={onChangeImagens}
                        name="logotipoBranco"
                        accept="image/png,image/jpeg" />
                </Col>
                {prefeitura.logotipoBranco &&
                    <Col md={"12"} lg={"12"} className="text-center">
                        <img
                            width={"300px"}
                            id="img_logotipoBranco"
                            src={"data:image/png;base64," + prefeitura.logotipoBranco}
                        />
                    </Col>
                }

                <Col md={"12"} lg="12">
                    <TextField
                        label={"Logotipo Secretaria Branco"}
                        type={"file"}
                        onChange={onChangeImagens}
                        name="logotipoSecretariaBranco"
                        accept="image/png,image/jpeg" />
                </Col>
                {prefeitura.logotipoSecretariaBranco &&
                    <Col md={"12"} lg={"12"} className="text-center">
                        <img
                            width={"300px"}
                            id="img_logotipo"
                            src={"data:image/png;base64," + prefeitura.logotipoSecretariaBranco}
                        />
                    </Col>
                }

                <Col md={"12"} lg="12">
                    <TextField
                        label={"Logotipo Qrcode"}
                        type={"file"}
                        onChange={onChangeImagens}
                        name="logotipoQRCode"
                        accept="image/png,image/jpeg" />
                </Col>
                {prefeitura.logotipoQRCode &&
                    <Col md={"12"} lg={"12"} className="text-center">
                        <img
                            width={"300px"}
                            id="img_logotipo"
                            src={"data:image/png;base64," + prefeitura.logotipoQRCode}
                        />
                    </Col>
                }
            </Row>
        </div>
    )
}